<template>
  <!-- 出入金流水 -->
  <div id="flow">
    <div class="chooseWrap">
      <div class="itemSearch">
        <div class="searchTitle">类型</div>
        <el-select v-model="typeCode" size="small" popper-class="_whiteSelect" placeholder="请选择" @change="param_queryMyIntegralDetail">
          <el-option label="全部" value="全部" />
          <el-option label="出金" value="102" />
          <el-option label="入金" value="101" />
          <el-option label="出金错误回滚资金" value="107" />
        </el-select>
      </div>
    </div>
    <div id="tablePage">
      <el-table
        ref="tableData"
        :data="tableData"
        :height="tableHeight"
        style="width: 100%">
        <template slot="empty">
          <div class="no-datas1">
            <div
              class="no-data-img"
              style="margin: 100px auto 0px; width: 120px; height: 200px;"
            >
              <img
                src="../../../assets/images/no_data.png"
                alt=""
                style="width: 100%;"
              >
              <span>暂无数据</span>
            </div>
          </div>
        </template>
        <el-table-column align="center" prop="flowId" label="记录流水">
        </el-table-column>
        <el-table-column align="center" prop="bizName" label="类型">
        </el-table-column>
        <el-table-column align="center" prop="marketName" label="转账系统">
        </el-table-column>
        <el-table-column align="center" prop="amount" label="发生额">
        </el-table-column>
        <el-table-column align="center" prop="balance" label="资金余额">
        </el-table-column>
        <!-- 转账银行 就是签约银行 -->
        <el-table-column align="center" prop="bankName" label="转账银行">
        </el-table-column>
        <el-table-column prop="occurTime" label="发生时间" width="90">
          <template slot-scope="scope">
            {{ scope.row.occurTime | dateFormate }}
          </template>
        </el-table-column>
      </el-table>
      <el-row v-if="pageData.total">
        <el-col :span="24" class="paginateWrap">
          <el-pagination
            class="paginationPage"
            popper-class="_popStyle"
            :current-page="pageData.currentPage"
            :page-sizes="pageData.pageSizes"
            :page-size="pageData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
/*global http protocol*/
export default {
  data() {
    return {
      typeCode: '全部',
      tableData: [],
      tableHeight: 0,
      pageData: {
        total: 0,
        pageSizes: [10, 20, 30, 40],
        pageSize: 20,
        currentPage: 1
      }
    }
  },
  mounted() {
    this.param_queryMyIntegralDetail()
  },
  created() {
    window.onresize = () => {
      this.$nextTick(() => {
        this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      })
    }
  },
  updated() {
    this.$nextTick(() => {
      this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      this.$refs['tableData'].doLayout()
    })
  },
  methods: {
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.param_queryMyIntegralDetail()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.param_queryMyIntegralDetail()
    },
    // 查询出入金流水
    param_queryMyIntegralDetail() {
      protocol.param_queryFirmBankAccountInoutFundsFlowFront.param.bizCode = this.typeCode == '全部' ? null : this.typeCode
      protocol.param_queryFirmBankAccountInoutFundsFlowFront.param.page = this.pageData.currentPage - 1
      protocol.param_queryFirmBankAccountInoutFundsFlowFront.param.size = this.pageData.pageSize
      http.postFrontChange(protocol.param_queryFirmBankAccountInoutFundsFlowFront, 0).then(response => {
        if (response.data) {
          if (response.data && response.data.code == '0') {
            this.pageData.total = response.data.value.totalElements
            const arr = response.data.value.content
            this.tableData = arr
          }
        }
      })
    }
  }
}
</script>
